import { DataBean } from "../DataBean";

export class InventoryCatalog extends DataBean {


   

    public async getInventoryCatalog(idLine: number, regexStr: string, type: number,productCode:any,reference:any,idProduct:any, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getInventoryCatalog_Number_String_Number_Number_Number_Number_Number_Number", [idLine, regexStr, type,productCode,reference,idProduct, page, recordsPerPage]);
    }
}